import { useCallback } from 'react';

import { InspoImportFlow } from '@/components/InspoImport/InspoImportFlow';
import { useInspoImport } from '@/contexts/InspoImportContext';

export default function InspoImportRouteModalHost() {
  const { isOpen, prefilledUrl, entrySource, closeInspoImport, clearPrefilledUrl } = useInspoImport();

  const handleClose = useCallback(() => {
    closeInspoImport();
  }, [closeInspoImport]);

  if (!isOpen) {
    return null;
  }

  return (
    <InspoImportFlow
      isModal
      prefilledUrl={prefilledUrl}
      entrySource={entrySource}
      clearPrefilledUrl={clearPrefilledUrl}
      onRequestClose={handleClose}
    />
  );
}
